var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinanceLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#181A20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4548 26.4892L29.9999 17.944L38.5491 26.4928L43.5211 21.5208L29.9999 8L16.4832 21.5168L21.455 26.4888L21.4548 26.4892ZM8 30L12.9722 25.0271L17.944 29.9989L12.9718 34.9711L8 30ZM21.4548 33.5114L29.9999 42.056L38.5489 33.5073L43.5235 38.4767L43.5211 38.4793L29.9999 52L16.4832 38.4832L16.4761 38.4762L21.4553 33.5108L21.4548 33.5114ZM42.0559 30.0021L47.028 25.0299L51.9998 30.0018L47.0278 34.9739L42.0559 30.0021Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0427 29.9974H35.0448L30 24.9521L26.2711 28.68L25.8427 29.1086L24.9592 29.9923L24.9521 29.9991L24.9592 30.0064L30 35.0479L35.0452 30.0027L35.0476 29.9998L35.0431 29.9974",
    fill: "#F3BA2F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceLogo);
export default __webpack_public_path__ + "static/media/binance-logo.cba16b5282be4406a7ff2ead8526a051.svg";
export { ForwardRef as ReactComponent };